import { i18n } from '@/plugins/i18n'

export const collectiveStatus = {
    ACTIVE: 1,
    INACTIVE: 0,
}

export const collectiveStatusStr = {
    ACTIVE: i18n.t('label.active'),
    INACTIVE: i18n.t('label.inactive'),
    get(status) {
        let status_str = null;
        Object.keys(collectiveStatus).forEach(function (item) {
            if(collectiveStatus[item] === status) {
                status_str = collectiveStatusStr[item]
            }
        })

        return status_str
    }
}

export const collectiveVariant = (status) => {
    if(status === collectiveStatus.ACTIVE) {
        return 'success'
    }

    if(status === collectiveStatus.INACTIVE) {
        return 'danger'
    }

    return 'info'
} 